/**
 * Platform URL resolution - single source of truth for all cross-links
 * from silker-ai-web → silker-ai-platform.
 *
 * Priority (highest → lowest):
 *  1. NEXT_PUBLIC_PLATFORM_URL  (explicit override - set this in .env.local for local dev)
 *  2. NODE_ENV === 'development' → http://localhost:3001
 *  3. https://platform.silkerai.com  (production default)
 */
export const PLATFORM_URL: string =
  process.env.NEXT_PUBLIC_PLATFORM_URL ||
  (process.env.NODE_ENV === 'development'
    ? 'http://localhost:3001'
    : 'https://platform.silkerai.com');

const registrationEnabled =
  process.env.NEXT_PUBLIC_ENABLE_REGISTRATION !== 'false';

export const platformLink = {
  register: (plan?: string) =>
    registrationEnabled
      ? `${PLATFORM_URL}/register${plan ? `?plan=${plan}` : ''}`
      : '/coming-soon',

  registerWithScan: (scan: string) =>
    registrationEnabled
      ? `${PLATFORM_URL}/register?scan=${encodeURIComponent(scan)}`
      : '/coming-soon',

  login: registrationEnabled ? `${PLATFORM_URL}/login` : '/coming-soon',

  dashboard: `${PLATFORM_URL}/apps`,

  shield: `${PLATFORM_URL}/shield`,
};
